const strings = {
  infoFarmer: 'Agricultores',
  addUser: 'Adicionar',
}

export default strings
